export enum SnackBarActionTypes {
    SHOW = '@@snackbar/SHOW',
    HIDE = '@@snackbar/HIDE'
}

export interface ISnackBarState {
    message: string | null;
    variant: 'success' | 'warning' | 'error' | 'info' | null;
}
